/**
 * Utility function to redirect to a given URL using the window.location object
 *
 * @param redirectUrl - The URL to redirect to
 * @returns void
 *
 * @memberof module:utils/startup
 *
 * @todo remove this function and use the redirectTo function from the utils package
 */
const redirectTo = (redirectUrl: string): void => {
    window.location.href = redirectUrl;
};

export default redirectTo;
